import { supabase } from './supabase'

export async function fetchNotifications({ limit = 50 } = {}) {
  if (!supabase) return { notifications: [], unread: 0 }
  const { data, error } = await supabase
    .from('notifications')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(limit)
  if (error) throw error
  const unread = (data || []).filter((n) => !n.read).length
  return { notifications: data || [], unread }
}

export async function markNotificationRead(id) {
  if (!supabase) return
  await supabase.from('notifications').update({ read: true }).eq('id', id)
}

export async function markAllNotificationsRead() {
  if (!supabase) return
  await supabase.from('notifications').update({ read: true }).eq('read', false)
}

export async function clearNotifications() {
  if (!supabase) return
  await supabase.from('notifications').update({ read: true }).neq('read', true).select()
}
